// Kleine Anzeige-Helfer fuer Namen, Dateigroessen und Antworten.

let germanCollator: Intl.Collator | null | undefined;

/** Vergleich fuer deutsche Namen (Umlaute, Zahlen natuerlich); faellt ohne Intl auf localeCompare zurueck. */
export function compareGermanText(a: string, b: string): number {
  if (germanCollator === undefined) {
    germanCollator =
      typeof Intl === 'undefined' ? null : new Intl.Collator(['de-CH', 'de'], { sensitivity: 'base', numeric: true });
  }
  return germanCollator ? germanCollator.compare(a, b) : a.localeCompare(b);
}

function firstCharacter(value: string): string {
  return Array.from(value)[0] ?? '';
}

function getEmailLocalPart(email: string | null | undefined): string {
  return (email ?? '').trim().split('@')[0] ?? '';
}

/**
 * Initialen: ersten Buchstaben der ersten zwei Woerter, bei einem Wort nur einen.
 * Ohne Namen zaehlt der lokale Teil der E-Mail (Punkt, Bindestrich, Unterstrich trennen Woerter).
 */
export function getInitials(name?: string | null, email?: string | null): string {
  const fromName = (name ?? '').trim().split(/\s+/).filter(Boolean);
  const words =
    fromName.length > 0
      ? fromName
      : getEmailLocalPart(email)
          .split(/[\s._+-]+/)
          .filter(Boolean);
  const initials = words.slice(0, 2).map(firstCharacter).join('').toUpperCase();
  return initials || '?';
}

/** Name fuer Anzeige: voller Name, sonst lokaler Teil der E-Mail, sonst fallback. */
export function getPersonDisplayName(fullName?: string | null, email?: string | null, fallback = ''): string {
  return fullName?.trim() || getEmailLocalPart(email) || fallback;
}

export function formatFileSize(bytes: number): string {
  if (!Number.isFinite(bytes) || bytes < 0) return '0 B';
  if (bytes < 1024) return `${bytes} B`;
  if (bytes < 1024 * 1024) return `${(bytes / 1024).toFixed(1)} KB`;
  return `${(bytes / (1024 * 1024)).toFixed(1)} MB`;
}

/** Antwort auf eine Event-Frage oder ein Profilfeld als Text: Ja/Nein, Listen mit Komma. */
export function formatAnswerValue(value: unknown): string {
  if (value === null || value === undefined) return '';
  if (typeof value === 'boolean') return value ? 'Ja' : 'Nein';
  if (Array.isArray(value)) return value.map(formatAnswerValue).join(', ');
  return String(value);
}
